import { render, staticRenderFns } from "./TranslateLanguage.vue?vue&type=template&id=629a4c10"
import script from "./TranslateLanguage.vue?vue&type=script&lang=js"
export * from "./TranslateLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports